import { Book, Club } from '@fable/types'
import { QueryKey, useQueryClient } from 'react-query'
import { useEffect } from 'react'
import { getBookDate, isBookPreorder, stripHtml } from '@fable/utils'
import { useQuery } from '@apollo/client'
import { FAQ_LIST } from 'queries'

export const bookMetadata = ({
  title,
  authors,
  description,
  cover_image_small,
}: Partial<Book>) => {
  const pageDescription = stripHtml(description || '')

  const author = !!authors?.length ? ` by ${authors[0].name}` : ''
  const metaTitle = `${title}${author}`

  return {
    title: metaTitle,
    description: pageDescription,
    image: cover_image_small,
  }
}

export const useClearQueries = ({ key }: { key?: QueryKey } = {}) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    return () => {
      if (key) return queryClient.removeQueries(key)
      queryClient.removeQueries()
    }
  }, [queryClient, key])
}

export const getBannerText = (book: Book) => {
  if (isBookPreorder(book)) {
    const date = getBookDate(book?.published_date)
    return `Available on ${date}. Preorder your ebook copy today.`
  }
  if (book?.is_out_of_catalog || !book?.can_purchase)
    return 'This book is not available to purchase on Fable'
}

export const getClubsReadingBook = ({
  clubs,
  book,
}: {
  clubs: Club[]
  book: Book
}) => {
  return clubs?.filter((club) => club?.current_book?.id === book?.id)
}

export const useBookFaq = ({ book }: { book: Book }) => {
  const isPreorder = isBookPreorder(book)

  const getType = () => {
    if (isPreorder) return 'preorder'
    if (book?.is_out_of_catalog) return 'outOfCatalog'
    return 'inCatalog'
  }

  const getQueryId = () => {
    switch (getType()) {
      case 'preorder':
        return '4gRjLLBsekOIusIzdJ76nz'
      case 'inCatalog':
        return '4MHm1xJIvE9XS98MUgDi2S'
      case 'outOfCatalog':
        return 'rOEipIHG0zcbeXGs3y561'
    }
  }

  const faqQuery = useQuery(FAQ_LIST, {
    variables: {
      id: getQueryId(),
    },
  })

  return faqQuery
}
